import React, { useEffect, useRef, useState } from "react";

function ScrollReveal({
  as: Tag = "div",
  children,
  className = "",
  delay = 0,
  variant = "up",
  distance = 28,
  style,
  ...props
}) {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -8% 0px",
      }
    );

    const target = elementRef.current;

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, []);

  return (
    <Tag
      ref={elementRef}
      className={`scroll-reveal scroll-reveal-${variant} ${isVisible ? "is-visible" : ""} ${className}`.trim()}
      style={{
        "--reveal-delay": `${delay}ms`,
        "--reveal-distance": `${distance}px`,
        ...style,
      }}
      {...props}
    >
      {children}
    </Tag>
  );
}

export default ScrollReveal;
